import Button from "../../../../entity/main-page/components/button";
import './style.scss'
import InputMask from "react-input-mask";
import {useState} from "react";
import Success from "../../../main/components/Popup/Success";
import axios from "axios";
import { SERVER_POST } from "../../../../const";

const Specialist = ({name, job, img}: { name: string, job: string, img: string }) => {
    const [formData, setFormData] = useState({
            phone: "",
            dataConsent: false,
        });
    const [error, setError] = useState("");
    const [successVisible, setSuccessVisible] = useState(false);

    const validatePhone = () => {
        const phoneRegex = /^(\+7|8)?[\s-]?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{2}[\s-]?\d{2}$/;
        const isPhoneValid = phoneRegex.test(formData.phone.trim());
        if (!isPhoneValid) {
            setError("Некорректный номер телефона");
            return false;
        }

        return true;
    }

    const validateForm = () => {
        const { dataConsent} = formData;

        if (
            !formData.phone ||
            !dataConsent
        ) {
            setError("Не все поля заполнены");
            return false;
        }

        if (!validatePhone()) {
            return false;
        }

        setError("");
        return true;
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
            const { name, value, type, checked } = e.target as HTMLInputElement;

            setFormData((prev) => ({
                ...prev,
                [name]: type === "checkbox" ? checked : value,
            }));    
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        console.log("Da-da");
        e.preventDefault();
        if (validateForm()) {
            try {
                const response = await axios.post(SERVER_POST, formData, {
                    headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                    },
                });

                if(response.status === 200) {
                    console.log('Данные успешно отправлены: ', formData);
                    setSuccessVisible(true);
                    setFormData({
                        phone: "",
                        dataConsent: false,
                    })
                }
            } catch (error) {
                console.error('Ошибка отправки данных:', error);
            }
        }
    };

    return (
        <>
            <form className="specialist" id={"specialist"} onSubmit={handleSubmit}>
                <div className="specialist__wrapper">
                    <div className="specialist__img">
                        <img src={img} alt={name}/>
                    </div>
                    <h4 className="specialist__name">{name}</h4>
                    <p className="specialist__job">{job}</p>
                    <InputMask
                        mask="+7 999 999 99 99"
                        value={formData.phone}
                        onChange={handleChange}
                        className="phone-input"
                        placeholder="+7 900 000 00 00"
                    >
                        {(inputProps: any) => <input type="tel" name={'phone'} {...inputProps}
                                                    className="specialist__phone"/>}
                    </InputMask>
        
                {error && <div className="formError">{error}</div>}
                <button className="header-button specialist__button" type="submit">Перезвоните мне</button>
                <label className="form-label-flex form-label-politic">
                        <input type="checkbox" name="dataConsent" id="dataConsentFour" onChange={handleChange} checked={formData.dataConsent}/>
                        <span>Я даю согласие на обработку своих персональных данных</span>
                    </label>
                </div>
            </form>
            {successVisible && <Success onClose={() => setSuccessVisible(false)}/>}
        </>
        
    )
}

export default Specialist